<!--<div class="tag fill" [class.fill]="active">
	<span>{{ text }}</span>
</div>-->

<button class="btn" [class.fill]="active" type="button">{{ text }}</button>
